import * as React from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { StepIconProps } from "@mui/material/StepIcon";
import { useOnboarding } from "src/store/features/onboarding.slice";
import { useUserSlice } from "src/store/features/user.slice";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#0BEC9F",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#0BEC9F",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")<{ ownerState: { active?: boolean } }>(
  ({ theme, ownerState }) => ({
    color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
    ...(ownerState.active && {
      color: "#002035",
    }),
    "& .QontoStepIcon-completedIcon": {
      color: "#0BEC9F",
      zIndex: 1,
      fontSize: 18,
    },
    "& .QontoStepIcon-circle": {
      width: 8,
      height: 8,
      borderRadius: "50%",
      backgroundColor: "currentColor",
    },
  }),
);

function QontoStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;
  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

export default function CustomizedSteppers() {
  const { applicationStep, accountType, reKycApplicationStep } = useOnboarding();

  const {
    reKycDetails: { reKyc, recordType },
  } = useUserSlice();

  const nonIndividualSteps = [
    "ID Verification",
    "About Your Entity",
    "About You",
    "Your Crypto Journey",
  ];
  const individualSteps = ["ID Verification", "About You", "Your Crypto Journey"];
  const rekycFormStepsIndividual = ["ID Verification", "About You"];
  const rekycFormStepsNonIndividual = ["About You", "About Your Entity", "ID Verification"];
  const isIndividual = accountType === "Individual";
  const isIndividualRecordType = recordType === "Individual";

  const individualActiveStep = () => {
    switch (applicationStep) {
      case "onfidoConsent":
      case "onfidoVerify":
        return 0;
      case "aboutYou":
        return 1;
      case "cryptoJourney":
        return 2;
      case "applicationSuccess":
        return 3;
      default:
        return 0;
    }
  };

  const nonIndividualActiveStep = () => {
    switch (applicationStep) {
      case "onfidoConsent":
      case "onfidoVerify":
        return 0;
      case "aboutYourEntity":
        return 1;
      case "aboutYou":
        return 2;
      case "cryptoJourney":
        return 3;
      case "applicationSuccess":
        return 4;
      default:
        return 0;
    }
  };

  const rekycActvieStepIndividual = () => {
    switch (reKycApplicationStep) {
      case "onfidoVerify":
        return 0;
      case "aboutYou":
        return 1;
      default:
        return 0;
    }
  };

  const rekycActvieStepEntity = () => {
    switch (reKycApplicationStep) {
      case "onfidoVerify":
        return 0;
      case "aboutYou":
        return 1;
      case "aboutYourEntity":
        return 2;
      default:
        return 0;
    }
  };

  return (
    <Stack sx={{ width: "100%" }} spacing={4} flexDirection={"-moz-initial"}>
      {isIndividualRecordType && reKyc && (
        <Stepper
          alternativeLabel
          activeStep={rekycActvieStepIndividual()}
          connector={<QontoConnector />}>
          {rekycFormStepsIndividual.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      )}
      {!isIndividualRecordType && reKyc && (
        <Stepper
          alternativeLabel
          activeStep={rekycActvieStepEntity()}
          connector={<QontoConnector />}>
          {rekycFormStepsNonIndividual.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      )}
      {isIndividual && !reKyc && (
        <Stepper
          alternativeLabel
          activeStep={individualActiveStep()}
          connector={<QontoConnector />}>
          {individualSteps.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      )}
      {!isIndividual && !reKyc && (
        <Stepper
          alternativeLabel
          activeStep={nonIndividualActiveStep()}
          connector={<QontoConnector />}>
          {nonIndividualSteps.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      )}
    </Stack>
  );
}
